import createDataSourceObject from './createDataSourceObject';

/**
 * Create a url for the current state of the data source.
 * @returns {string}
 */
export default (state, settings = { dataSourceUrlKey: 's' }) => {
  const { origin, pathname } = window.location;
  const sourceObject = createDataSourceObject(state);

  return `${origin}${pathname}?${settings.dataSourceUrlKey}=${btoa(JSON.stringify(sourceObject))}`;
};
